import { preferencia } from '../lib/tema';

/* =====================================================================
   LAS MEDIDAS DE LAS PUERTAS · lo que no es un componente
   =====================================================================
   Aparte de `puerta.jsx` y no dentro por una razón de herramienta: un
   archivo que exporta componentes Y constantes rompe la recarga en
   caliente de React, y el lint lo dice. Aparte, los dos funcionan.

   ESTAS MEDIDAS SON EL CONTRATO DE LAS TRES PUERTAS. La consola de
   operador no puede importarlas —es HTML y CSS a pelo, por su política
   de contenido— así que están repetidas en `consola/estatico/consola.css`
   con una nota que apunta aquí. Si una cambia, cambian las dos.

       campo     48 px de alto, radio 4, borde de 1 px que se ve
       botón     48 px, radio 4, color sólido a plena fuerza
       etiqueta  13 px, semibold, 6 px de aire debajo
       panel     55 % / 45 %, desaparece por debajo de 1024 px
       reparto   marca arriba · frase al centro · pie abajo
   ===================================================================== */

// EL TEXTO DEL CAMPO VA A 16 px (`text-base`), NO A 15 (M5 · F3, 23 de
// septiembre de 2026). Por debajo de 16 px, Safari de iPhone hace zoom
// solo al tocar el campo —la pantalla salta y el formulario se
// descuadra— y el cuerpo del texto baja del mínimo legible de la
// directriz. Es el mismo arreglo que subió los `<p class="dim">` del
// sitio de 15 a 16 en F2, ahora en las TRES puertas a la vez (entrar,
// alta y verificación de correo), que comparten esta medida. El alto
// (`h-12` = 48 px) ya cumple el blanco táctil de M4.
export const CLASE_CAMPO =
  'w-full h-12 px-3 rounded border bg-[var(--p-superficie)] text-base ' +
  'text-[var(--p-tinta)] placeholder-[var(--p-tinta-3)] outline-none ' +
  'transition-colors duration-150 focus:ring-2 focus:ring-[var(--p-marca)]/30';

/* LA PUERTA ARRANCA EN CLARO AUNQUE EL SISTEMA ESTÉ EN OSCURO, y solo
   cambia si la persona lo eligió a mano. Es la primera impresión de la
   marca y tiene que ser siempre la misma; pero si alguien ya dijo que
   trabaja de noche, se le respeta. Lo lee de la PREFERENCIA guardada y no
   del tema pintado: son cosas distintas. */
export function temaDeLaPuerta() {
  return preferencia() === 'sistema' ? 'claro' : preferencia();
}
